import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-07-18T17:30:00+02:00").getTime();

function getRemaining() {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const Cell = ({ value, label, testid }) => (
  <div className="flex-1 text-center" data-testid={testid}>
    <div className="font-serif text-[2.4rem] sm:text-[3.4rem] leading-none text-[color:var(--ink-wine)] tabular-nums font-medium">
      {String(value).padStart(2, "0")}
    </div>
    <div className="mt-1 text-[0.6rem] sm:text-[0.7rem] tracking-[0.25em] uppercase text-[color:var(--ink-wine)] font-semibold">
      {label}
    </div>
  </div>
);

export default function CountdownCard({ t }) {
  const [r, setR] = useState(getRemaining());
  useEffect(() => {
    const i = setInterval(() => setR(getRemaining()), 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div
      data-testid="countdown-card"
      className="s-card s-card-pad mx-auto max-w-md w-full"
    >
      <div className="text-center">
        <p className="text-xs tracking-[0.3em] uppercase font-semibold text-[color:var(--ink-deep)] mb-1">
          {t.inicio.countdown}
        </p>
        <div className="s-divider" />
      </div>
      <div className="flex items-end justify-between gap-1 sm:gap-3 mt-2">
        <Cell value={r.days} label={t.inicio.days} testid="cd-days" />
        <span className="font-serif text-2xl sm:text-4xl text-[color:var(--ink-wine)]/40 -mt-3">·</span>
        <Cell value={r.hours} label={t.inicio.hours} testid="cd-hours" />
        <span className="font-serif text-2xl sm:text-4xl text-[color:var(--ink-wine)]/40 -mt-3">·</span>
        <Cell value={r.minutes} label={t.inicio.min} testid="cd-min" />
        <span className="font-serif text-2xl sm:text-4xl text-[color:var(--ink-wine)]/40 -mt-3">·</span>
        <Cell value={r.seconds} label={t.inicio.seg} testid="cd-seg" />
      </div>
      <div className="mt-5 text-center">
        <p className="text-sm text-[color:var(--ink-deep)] font-medium">{t.inicio.when}</p>
        <p className="text-[0.7rem] mt-1 tracking-[0.22em] uppercase font-semibold text-[color:var(--ink-wine)]/80">
          {t.inicio.where}
        </p>
      </div>
    </div>
  );
}
